import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BaseAPIService } from '@app/Services/api.base.service';
import { rolesdef } from '@app/constants/role-def';

@Component({
  selector: 'app-role-selection',
  standalone: false,
  templateUrl: './role-selection.component.html',
  styleUrls: ['./role-selection.component.scss']
})
export class RoleSelectionComponent {
  roles: string[] = [];
  selectedRole: string | null = null;
  loading = false;
  role = rolesdef
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly apiService: BaseAPIService
  ) {}

  selectRole(selectedRole: string): void {
    
    if (this.loading) {
      return;
    }
    this.selectedRole = selectedRole;
    

    // Call PATCH API to update user role
    this.apiService.PatchTextAsJSON(`/User/UpdateUserRoleInRoleSelection?selectedRoleCode=${this.selectedRole}`, {}).subscribe(
      (response: any) => {
        if (this.selectedRole === 'INSTALLER') {
          // Response is a token string, not JSON
          sessionStorage.removeItem('token');
          sessionStorage.setItem('token', response);
        }
        // After role selection, show terms popup (if not accepted) then navigate to dashboard
        this.authenticationService.onRoleSelectionComplete();
      },
      (error) => {
        console.error('Failed to update user role:', error);
        
      }
    );
  }

  private saveRoleSelection(role: string) {
    return this.apiService.POST('User/SetUserRole', { role }); // legacy, not used
  }
}
